module.exports = __webpack_public_path__ + "static/img/spacex_logo_small.7f46b5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spacex_logo_small.png
// module id = Ntwd
// module chunks = 1